import type { RetailMediaDecision } from '../../../query/retailMediaDecision';

export enum Vendor {
  Disco = 'DISCO',
  Thanks = 'THANKS',
  Fetch = 'FETCH',
}

export interface RetailMediaProps {
  featureName?: string;
  fixedPanelHeight?: string;
  appsJwt?: string;
  decision?: RetailMediaDecision | null;
  visitId?: string;
  visitNumber?: number;
  suppressed?: boolean;
}
